import { db, auth } from '../../../firebase'
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'

/**
 * Business audit trail for the Exchange Desk (gold_audit_logs).
 * Append-only from the client (rules block update/delete); never blocks the
 * action being audited.
 */
export async function logGoldEvent(action, details = {}) {
  try {
    await addDoc(collection(db, 'gold_audit_logs'), {
      action,
      details,
      userEmail: auth.currentUser?.email || null,
      uid: auth.currentUser?.uid || null,
      createdAt: serverTimestamp(),
    })
  } catch (err) {
    console.warn('gold audit log failed:', err?.message || err)
  }
}
